/**
 * created by Felicia Dumitrache
 */
import BaseComponent from "../../base/base_component";

export default class GameHostComponent extends BaseComponent{

    /**
     * @type {string}
     */
    static CLASS = "GameHostComponent";

    /**
     * @type {string}
     */
    static DIRECTIVE = "cgp-directive-game_host";

    /**
     * game type received in params on init
     * @type {String}
     * @private
     */
    _gameType = null;

    init(params={}){
        super.init(params);
        this._gameType = params.gameType;
    }

    /**
     * tries open game
     * @returns {GameHostComponent}
     */
    start(){
        this.openGame();
        return this;
    }

    /**
     * call game service to open demo game
     * set style for centering the game after game loaded
     */
    openGame(){
        this.serviceFactory.gameService().openAnonymousGame({
            gameType: this._gameType,
            skipShowGame: true,
            isReal: false,
            forceLogin: false
        }).then(gameOptions => {
            this.serviceFactory.structuredLoggingService().getLogger({
                eventName: 'OPENING_ANONYMOUS_GAME_BY_GAME_HOST',
                gameType: this._gameType
            }).info();
            this.appendChildComponent(gameOptions.gameBody);
        });
    }
}